import styled from 'styled-components'
import { Form } from '@unform/web';

export const ButtonWrapper = styled.div`
    width:100%;
    display:flex;
    align-items:center;
    justify-content:flex-end;
    padding: 1.5rem 0;

    button{
        display:block;
    }
`

export const HeaderWrapper = styled(Form)`
    display:flex;
    flex-flow:column;
    div.MuiFormControl-root{
        max-width:600px;
        margin: 5px 0px;
    }

    @media(max-width: 425px){
        display:none;
    }
`;
